module.exports = {"black":"black","blue":"blue","green":"green","lime":"lime","orange":"orange","pink":"pink","purple":"purple","red":"red","sky":"sky","yellow":"yellow"}


//////////////////
// WEBPACK FOOTER
// ./resources/strings/labels/en.json
// module id = iz4c
// module chunks = 26 27 28